import * as React from 'react';
import cx from 'classnames';

const Input = (props) => {
  const {
    field,
    form: { touched, errors, setFieldValue },
    disabled,
    label,
    type,
    className,
    inputClassName,
    inputStep,
    inputSign,
    placeholder,
    checked,
    cbChange,
    customStyle,
    inputHint,
  } = props;

  const cn = cx(className || 'input', {
    'input--err': errors[field.name],
    'input--touched': field.value,
  });

  const onChange = (check) => {
    const target = check.target.checked;
    setFieldValue(field.name, target);
    if (cbChange) cbChange(field, target);
  };

  const renderInput = () => {
    switch (type) {
      case 'textarea':
        return (
          <textarea
            disabled={disabled}
            className={`${inputClassName || ''}`}
            placeholder={placeholder || label}
            {...field}
            value={field.value || ''}
            style={customStyle}
          />
        );
      case 'checkbox': {
        return (
          <input
            type={type}
            disabled={disabled}
            className={`${inputClassName || ''}`}
            placeholder={placeholder || label}
            {...field}
            checked={checked}
            onChange={onChange}
            style={customStyle}
          />
        );
      }
      default:
        return (
          <input
            type={type}
            disabled={disabled}
            className={`${inputClassName || ''}`}
            placeholder={placeholder || label}
            {...field}
            value={typeof field.value === "number" ? field.value : field.value || ""}
            style={customStyle}
          />
        )
    }
  };

  return (
    <div className={cn}>
      {inputStep && <span className="input__step">{inputStep}</span>}
      {inputSign && <span className="input--sign__sign">{inputSign}</span>}

      {renderInput()}

      {label && <label className="input__lbl">{label}</label>}
      {touched[field.name] && errors[field.name] && <span className="input--err__msg">{errors[field.name]}</span>}
      {inputHint && <div className="input__hint">{inputHint}</div>}
    </div>
  );
};

export default Input;
